import type { Building } from "building-types/building/buildingTypes";
import type {
  FramingKAM,
  FramingKAMOptions,
  FramingKeyAttributes,
  FramingKeyMeasures,
} from "building-types/dataSequences/builtin/FramingKAM";
import type { BuildingEntityFilter } from "building-types/dataSequences/filterableBuildingEntityTypes";
import type { KeyAttributesAndMeasuresDisplayOptions } from "building-types/dataSequences/measures";
import type { StandardLumberCounter } from "building-types/framing/lumberTypes";
import {
  keyAttributeNew,
  keyMeasureNew,
  keyAttributeOptionsNew,
  keyMeasureOptionsNew,
} from "doc/utils/dataSequenceTools";
import { makeBuildingFraming } from "procure/house/makeBuildingFraming";

export function makeFramingKAM(item: StandardLumberCounter): FramingKAM {
  return {
    type: "FRAMING",
    attributes: {
      profile: keyAttributeNew(item.profileDescriptor.name),
      profileType: keyAttributeNew(item.profileDescriptor.type),
      length: keyAttributeNew(item.lengthDescriptor.name, "FEET"),
      lengthType: keyAttributeNew(item.lengthDescriptor.type),
      entityName: keyAttributeNew(item.profileDescriptor.type + item.lengthDescriptor.type),
    },
    measures: {
      length: keyMeasureNew(item.lengthDescriptor.length, "FEET", "INCHES"),
      count: keyMeasureNew(item.count),
    },
    handles: [],
  };
}
export const EMPTY_FRAMING_KAM: FramingKAM = {
  type: "FRAMING",
  attributes: {
    profile: keyAttributeNew(""),
    profileType: keyAttributeNew(""),
    length: keyAttributeNew("", "FEET"),
    lengthType: keyAttributeNew(""),
    entityName: keyAttributeNew(""),
  },
  measures: {
    length: keyMeasureNew(0, "FEET"),
    count: keyMeasureNew(0),
  },
  handles: [],
};
export function makeDefaultFramingKAMOptions(): FramingKAMOptions {
  return {
    attributes: {
      length: keyAttributeOptionsNew({ unit: "FEET" }),
      entityName: keyAttributeOptionsNew({ definesEntity: false }),
    },
    measures: {
      length: keyMeasureOptionsNew({ unit: "FEET" }),
    },
  };
}
export const defaultFramingKAMSort = (a: FramingKAM, b: FramingKAM) => {
  return b.measures.count.value - a.measures.count.value;
};

/** @deprecated - use the Building Query API instead */
export function buildingFramingKAMs(building: Building, filter?: BuildingEntityFilter): FramingKAM[] {
  const { lumberCounters } = makeBuildingFraming(building, filter);
  const result: FramingKAM[] = [];
  for (const itemId in lumberCounters) {
    result.push(makeFramingKAM(lumberCounters[itemId]));
  }
  return result;
}

export const FRAMING_DISPLAY_OPTIONS: KeyAttributesAndMeasuresDisplayOptions<FramingKeyAttributes, FramingKeyMeasures> =
  {
    attributes: {
      entityName: {
        hidden: true,
      },
      profileType: {
        hidden: true,
      },
      lengthType: {
        hidden: true,
      },
    },
  };

// Attributes used in procure entityHash
export const DEFINES_FRAMING: (keyof FramingKeyAttributes)[] = ["profileType", "lengthType"];
